export default "__VITE_ASSET__C7aztd8W__"